(() => {
  const popup = document.getElementById('LfMarketPopup');
  if (!popup || document.documentElement.classList.contains('shopify-design-mode')) return;
  const subscriberKey = 'lf-newsletter-known-v1';
  const dismissalKey = 'lf-newsletter-dismissed-v1';
  const sessionKey = 'lf-newsletter-shown-v1';
  const read = (storage, key) => { try { return storage.getItem(key); } catch { return null; } };
  const write = (storage, key, value) => { try { storage.setItem(key, value); } catch {} };
  const hide = () => { popup.hidden = true; };
  const known = () => {
    write(localStorage, subscriberKey, 'true');
    hide();
  };
  const dismiss = () => {
    write(localStorage, dismissalKey, String(Date.now()));
    hide();
  };
  popup.querySelector('[data-lf-popup-close]')?.addEventListener('click', dismiss);
  popup.querySelector('[data-lf-popup-existing]')?.addEventListener('click', known);
  popup.addEventListener('keydown', event => { if (event.key === 'Escape') dismiss(); });
  window.addEventListener('storage', event => { if (event.key === subscriberKey || event.key === dismissalKey) hide(); });
  document.addEventListener('click', event => { if (event.target.closest('[data-lf-existing-access]')) known(); });
  const source = new URLSearchParams(location.search);
  if (source.get('utm_medium')?.toLowerCase() === 'email' || document.querySelector('[data-lf-signup-success]')) known();
  if (popup.querySelector('[data-lf-popup-success]')) {
    known();
    if (location.hash === '#LfMarketSignup') popup.hidden = false;
    return;
  }
  if (popup.querySelector('[role="alert"]')) { popup.hidden = false; return; }
  const suppressed = () => {
    const giftAccess = Object.keys(sessionStorage).some(key => key.startsWith('lf-gift-builder-access-') && read(sessionStorage,key) === 'true');
    return read(localStorage,subscriberKey) === 'true' || giftAccess || read(sessionStorage,sessionKey) === 'true' || Date.now() - Number(read(localStorage,dismissalKey) || 0) < 30 * 86400000;
  };
  const attempt = () => {
    try { if (suppressed()) return; } catch { return; }
    if (document.visibilityState !== 'visible') { setTimeout(attempt,5000); return; }
    const gift = document.querySelector('[data-lf-signup-panel]:not([hidden])');
    const box = gift?.getBoundingClientRect();
    const busy = document.activeElement?.matches('input,textarea,select') || document.querySelector('dialog[open],[aria-modal="true"]');
    if (busy || (box && box.top < innerHeight && box.bottom > 0)) { setTimeout(attempt,10000); return; }
    popup.hidden = false;
    write(sessionStorage,sessionKey,'true');
  };
  setTimeout(attempt,20000);
})();